<template>
  <b-card
    v-if="data"
    no-body
    class="card-developer-meetup"
  >
    <div class="bg-white rounded-top text-center">
      <b-img
        :src="data.avatar"
        :alt="data.name"
        height="150"
      />
    </div>
    <b-card-body class="bg-light-primary">
      <!-- speaker header -->
      <div class="meetup-header d-flex align-items-center">
        <div class="my-auto">
          <b-card-title class="mb-25">
            {{ data.fullName }}
          </b-card-title>
          <b-card-text class="mb-0">
            {{ data.description }}
          </b-card-text>
        </div>
      </div>
      <!--/ speaker header -->

    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BImg, BCardBody, BCardText, BCardTitle, BMedia, BMediaAside, BAvatar, BAvatarGroup, VBTooltip, BMediaBody, BButton
} from 'bootstrap-vue'

export default {
  name: "SupporterCard",
  components: {
    BCard,
    BImg,
    BCardBody,
    BCardText,
    BCardTitle,
    BMedia,
    BMediaAside,
    BAvatar,
    BAvatarGroup,
    BMediaBody,
    BButton,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
}
</script>
